import { gql, useQuery } from "@apollo/client";
import {
  GetCampaignQueryQuery
} from "../../../../../schemaTypes";

export const getCampaignQuery = gql`
  query GetCampaignQuery {
    getCampaign {
      id
      title
      description
      question
      bannerUrl
      campaignType
      pollOptions
      location
      community
      campaignLink
      colorCode
    }
  }
`;

export interface WithGetCampaign {
  id: string;
  title: string;
  description: string;
  question: string;
  bannerUrl: string;
  campaignLink: string;
  pollOptions: string[];
  location: string[];
  community: string[];
  campaignType: string;
  colorCode: string;
  loading: boolean;
}

export const useGetCampaign = (): WithGetCampaign => {
  const { data, loading } = useQuery<
    GetCampaignQueryQuery
  >(getCampaignQuery);

  if (!data?.getCampaign) {
    return {
      id: "",
      title: "",
      description: "",
      question: "",
      bannerUrl: "",
      campaignLink: "",
      pollOptions: [],
      location: [],
      community: [],
      campaignType: "",
      colorCode: "",
      loading,
    };
  }

  const campaign = data.getCampaign;
  const campaignTargeting = campaign as typeof campaign & {
    location?: (string | null)[] | null;
    community?: (string | null)[] | null;
  };

  const normalizeStringArray = (values?: (string | null)[] | null) =>
    values?.filter((value): value is string => typeof value === "string" && value.trim().length > 0) || [];

  return {
    id: campaign.id ?? "",
    title: campaign.title ?? "",
    description: campaign.description ?? "",
    question: campaign.question ?? "",
    bannerUrl: campaign.bannerUrl ?? "",
    campaignLink: campaign.campaignLink ?? "",
    pollOptions: normalizeStringArray(campaign.pollOptions),
    location: normalizeStringArray(campaignTargeting.location),
    community: normalizeStringArray(campaignTargeting.community),
    campaignType: campaign.campaignType ?? "",
    colorCode: campaign.colorCode ?? "",
    loading,
  };
};